export const SET_ALERT = 'alerts/SET_ALERT';
export const REMOVE_ALERT = 'alerts/REMOVE_ALERT';
export const REMOVE_ALL_ALERTS = 'alerts/CLEAR_ALL';

export const setAlert = alert => {
    return {
        type: SET_ALERT,
        value: { alert }
    };
};

export const removeAlert = alert => {
    return {
        type: REMOVE_ALERT,
        value: { alert }
    };
};

export const removeAllAlerts = () => {
    return {
        type: REMOVE_ALL_ALERTS
    };
};
